import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import './Fireworks.css';

const Fireworks = ({ show, onComplete }) => {
  const [particles, setParticles] = useState([]);
  const theme = useTheme();

// Function để phát âm thanh applause
const playFireworkSound = () => {
  try {
    const audio = new Audio('./applause.mp3');
    audio.volume = 0.7; // Set âm lượng 70%
    audio.currentTime = 0; // Bắt đầu từ đầu file
    
    // Phát âm thanh
    audio.play().catch(error => {
      console.log('Audio playback failed:', error);
    });
    
    // Dừng âm thanh sau 4 giây
    setTimeout(() => {
      audio.pause();
      audio.currentTime = 0;
    }, 4000);
    
  } catch (error) {
    console.log('Audio not supported:', error);
  }
};


  useEffect(() => {
    if (show) {
      // Tạo nhiều đợt pháo hoa
      const createFireworks = () => {
        const newParticles = [];
        
        // Tạo 5 đợt pháo hoa với thời gian khác nhau
        for (let i = 0; i < 5; i++) {
          setTimeout(() => {
            // Phát âm thanh pháo hoa
            playFireworkSound();
            
            const fireworkParticles = [];
            const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4', '#ffeaa7', '#dda0dd', '#98d8c8'];
            const centerX = Math.random() * 80 + 10; // 10% to 90% of screen width
            const centerY = Math.random() * 40 + 20; // 20% to 60% of screen height
            
            // Tạo 20 hạt cho mỗi đợt pháo hoa
            for (let j = 0; j < 20; j++) {
              const angle = (j / 20) * 2 * Math.PI;
              const velocity = Math.random() * 100 + 50;
              const color = colors[Math.floor(Math.random() * colors.length)];
              
              fireworkParticles.push({
                id: `${i}-${j}`,
                x: centerX,
                y: centerY,
                vx: Math.cos(angle) * velocity,
                vy: Math.sin(angle) * velocity,
                color: color,
                life: 1,
                delay: i * 300 // Delay giữa các đợt pháo hoa
              });
            }
            
            setParticles(prev => [...prev, ...fireworkParticles]);
          }, i * 300);
        }
      };

      createFireworks();

      // Tự động ẩn sau 6 giây
      const timer = setTimeout(() => {
        setParticles([]);
        if (onComplete) {
          onComplete();
        }
      }, 6000);

      return () => clearTimeout(timer);
    }
  }, [show, onComplete]);

  if (!show) return null;

  return (
    <div className="fireworks-container">
      {particles.map((particle) => (
        <div
          key={particle.id}
          className="firework-particle"
          style={{
            '--start-x': `${particle.x}%`,
            '--start-y': `${particle.y}%`,
            '--end-x': `${particle.x + particle.vx / 10}%`,
            '--end-y': `${particle.y + particle.vy / 10}%`,
            '--color': particle.color,
            '--delay': `${particle.delay}ms`
          }}
        />
      ))}
      
      {/* Thêm text chúc mừng */}
      <div className="congratulations-text">
        <Typography variant="h3" component="h1" sx={{ color: 'text.primary', fontWeight: 'bold', mb: 2 }}>
          🎉 Congratulations! 🎉
        </Typography>
        <Typography variant="h5" component="p" sx={{ color: 'text.primary' }}>
          You have completed all the modules!
        </Typography>
      </div>
    </div>
  );
};

export default Fireworks;